import * as React from 'react';
import ModalHandlerComponent from 'src/modules/commons/modal-handler/ModalHandler.component';

import { RootState } from 'src/reducers/RootReducer';
import { connect } from 'react-redux';

interface StateProps {
  modalContent?: JSX.Element;
  className?: string;
}

interface Props extends StateProps {
}

class ModalHandlerContainer extends React.Component<Props> {
  public render(): React.ReactNode {
    return <ModalHandlerComponent className={this.props.className} modalContent={this.props.modalContent}/>;
  }
}

const mapStateToProps: (state: RootState) => StateProps = (state: RootState): StateProps => {
  return {
    modalContent: state.activeModals.modalContent,
    className: state.activeModals.className,
  };
};

export default connect(mapStateToProps)(ModalHandlerContainer);


// WEBPACK FOOTER //
// ./src/modules/commons/modal-handler/ModalHandler.container.tsx